import GlobalTable from '@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue';
import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";
import alert_mixin from '@/utils/mixins/alert_mixin';
import formatting_mixins from '@/utils/mixins/formatting_mixins';


export default{
  name:'InvoiceOverview',
  mixins: [alert_mixin, formatting_mixins],
  components:{
      NavigationBackButton, GlobalTable
    },

  data: () => ({
    created_invoice: [
      {
        No: 1,
        invoice_name: "Commercial Invoice",
        date_generated: "2024-01-01 10:10:01am",
        date_due: "2025-05-01 11:10:11am",
        status: "partially paid",
      },

      {
        No: 2,
        invoice_name: "Final Invoice",
        date_generated: "2025-05-30 01:10:01pm",
        date_due: "2024-01-05 10:11:01am",
        status: "Sent"
        },

    ],
    invoice_date: '',
    invoice_due_date: '',
    invoice_items: [
      { description: '', quantity: 1, rate: 0 },
    ],
      invoice_data: {},
  }),

  computed: {
    subtotal() {
      return this.invoice_items.reduce((total, item) => total + item.quantity * item.rate, 0);
    },

    tax() {
      return this.invoice_items
      .filter(item => item.taxable)
      .reduce((total, item) => total + item.quantity * item.rate * 0.15, 0);
    },

    total() {
      return this.subtotal + this.tax;
    },
  },

  methods: {
    add_item() {
      this.invoice_items.push({ description: '', quantity: 1, rate: 0, taxable: true  });
    },
    remove_item(index) {
      this.invoice_items.splice(index, 1);
    },

    prepare_invoice_data() {
    this.invoice_data = {
      date: this.format_date(this.invoice_date),
      due_date: this.format_date(this.invoice_due_date),
      items: this.invoice_items,
      subtotal: this.subtotal,
      tax: this.tax,
      total: this.total
    };
  },

  },

}